import { useEffect, useState } from "react";
import Select from "react-select";
import { fetchCountries } from "../../services/meta";

function CountrySelect(props) {
  const { inputName, onChangeCountryOption, selectedValues, isMultiple } =
    props;
  const [countryOptions, setCountryOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  useEffect(() => {
    const _fetchCountryLists = async () => {
      await fetchCountries()
        .then((response) => {
          const { data } = response;
          if (data.data.countries) {
            const _options = [];
            const _selectedOptions = [];
            data.data.countries.forEach((v) => {
              _options.push({
                value: v["id"],
                label: v["name"],
              });
              if (selectedValues.includes(v["id"])) {
                _selectedOptions.push({
                  value: v["id"],
                  label: v["name"],
                });
              }
            });
            setCountryOptions(_options);
            if (_selectedOptions.length) {
              setSelectedOptions(_selectedOptions);
            }
          }
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    };
    _fetchCountryLists();
  }, []);
  return (
    <Select
      isMulti={isMultiple}
      name={inputName}
      options={countryOptions}
      value={selectedOptions}
      onChange={(e) => {
        if (selectedOptions) {
          setSelectedOptions(e);
        }
        if (onChangeCountryOption) {
          const _selectedOptions = [];
          e.forEach((v) => {
            _selectedOptions.push(v["value"]);
          });
          onChangeCountryOption(_selectedOptions);
        }
      }}
    />
  );
}

CountrySelect.defaultProps = {
  inputName: "country_id",
  onChangeCountryOption: null,
  selectedValues: [],
  isMultiple: false,
};

export default CountrySelect;
